class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
document.addEventListener('DOMContentLoaded', () => {
  const HEADER_FACET = '.sf-menu__content .facets__disclosure-vertical.header-facet';

  function getDropdown(wrapper) {
    return (
      wrapper?.querySelector('.dropdown-menu.facets-wrap-vertical') ||
      wrapper?.querySelector('.dropdown-menu.bg-white') ||
      wrapper?.querySelector('.dropdown-menu')
    );
  }

  function expand(el) {
    if (!el) return;

    el.style.overflow = 'hidden';

    // If it's already expanded but height is 0/empty, fix it.
    if (!el.classList.contains('expanded')) {
      el.classList.add('expanded');
    }

    // Start from current height (or 0), then animate to scrollHeight
    const start = el.getBoundingClientRect().height || 0;
    el.style.height = `${start}px`;

    requestAnimationFrame(() => {
      el.style.height = `${el.scrollHeight}px`;
    });

    // After the animation, set to auto so content can grow/shrink naturally
    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', onEnd);
      if (el.classList.contains('expanded')) el.style.height = 'auto';
    };
    el.addEventListener('transitionend', onEnd);
  }

  function collapse(el) {
    if (!el) return;

    el.style.overflow = 'hidden';

    // If height is auto, lock it to px first so it can animate down
    el.style.height = `${el.scrollHeight}px`;

    requestAnimationFrame(() => {
      el.style.height = '0px';
      el.classList.remove('expanded');
    });
  }

  function openFirstFacetOnLoad() {
    const wrapper = document.querySelector(HEADER_FACET);
    if (!wrapper) return;

    const dropdown = getDropdown(wrapper);
    const firstToggle = wrapper.querySelector('.toggle-dropdown');
    if (!dropdown) return;

    // Ensure it starts closed in CSS (height:0) but open it right away
    if (!dropdown.classList.contains('expanded')) {
      dropdown.style.height = '0px';
      expand(dropdown);

      // Keep your “plus” icon rotation behavior
      firstToggle?.querySelector('span.icon-plus')?.classList.add('rotate-130');
      // If you also want the chevron rotated for the first item:
      firstToggle?.querySelector('svg')?.classList.add('rotate-90');
    }
  }

  function toggleDropdown(button) {
    const li = button.closest('li');
    const dropdown = li?.querySelector('.dropdown-menu.bg-white') || li?.querySelector('.dropdown-menu');
    if (!dropdown) return;

    const isOpen = dropdown.classList.contains('expanded');

    if (isOpen) {
      collapse(dropdown);
    } else {
      expand(dropdown);
    }

    // Rotate the svg chevron on the clicked button
    button.querySelector('svg')?.classList.toggle('rotate-90');
  }

  // ✅ OPEN FIRST ITEM ON LOAD
  openFirstFacetOnLoad();
  // (optional) do it again next frame in case layout/fonts affect scrollHeight
  requestAnimationFrame(openFirstFacetOnLoad);

  // Delegate clicks for all toggle buttons
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.toggle-dropdown.flex');
    if (!btn) return;
    e.preventDefault();
    toggleDropdown(btn);
  });

  // Chevron-only widget
  const chevronContainer = document.querySelector('.custom_rotate_chevron_icon');
  const chevronIcon = chevronContainer?.querySelector('.icon-chevron_bestsellers');
  if (chevronIcon) {
    chevronIcon.style.transform = 'rotate(90deg)';
    chevronContainer.addEventListener('click', () => {
      chevronIcon.style.transform =
        chevronIcon.style.transform === 'rotate(90deg)'
          ? 'rotate(0deg)'
          : 'rotate(90deg)';
    });
  }
});